<template>
  <div>
    <div
      @click="backToTeam"
      class="
        flex
        items-center
        gap-2
        m-3
        cursor-pointer
        rounded-full
        w-max p-2
        justify-center
        text-sm
        bg-white
      "
    >
      <img class="h-4 object-contain" src="@/assets/icons/left.png" />
      <p>Back to your team</p>
    </div>

    <div class="bg-white m-3 rounded-md">
      <div class="flex flex-wrap justify-between gap-4 p-4">
        <div class="flex gap-5 items-center w-44">
          <div class="h-8 w-8 rounded-full">
            <img
              class="h-full w-full rounded-full"
              src="https://cdn2.iconfinder.com/data/icons/flatfaces-everyday-people-square/128/african_flatcut_boy_man_black_face_avatar-512.png"
            />
          </div>
          <p>John Doe</p>
        </div>
        <div
          v-for="(stat, index) in stats"
          :key="index"
          class="flex justify-between gap-3 w-full lg:w-max items-center border-1.5 p-2 rounded"
        >
          <p class="text-sm">{{ stat.name }}</p>
          <p class="text-green-500 font-bold text-sm">{{ stat.value }}</p>
        </div>
      </div>
    </div>
    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Leave request</p>
      </div>
      <div class="flex gap-4 bg-white mt-4 mb-2 mx-3">
        <select class="rounded-xl w-full pl-4 py-1 bg-gray-200">
          <option>Leave type</option>
        </select>
        <select class="rounded-xl w-full pl-4 py-1 bg-gray-200">
          <option>Leave Status</option>
        </select>
        <input
          type="date"
          placeholder="Department"
          class="rounded-xl w-full pl-4 py-1 bg-gray-200"
        />
        <input
          type="date"
          placeholder="location"
          class="rounded-xl w-full pl-4 py-1 bg-gray-200"
        />
      </div>
      <div class="p-2">
        <ve-table :columns="columns" :table-data="tableData" />
      </div>
    </div>

    <div class="bg-white m-3 rounded-md">
      <div class="border-b-0.5 flex justify-between items-center p-3">
        <p class="text-sm font-semibold">Leave History</p>
      </div>
      <div class="p-2">
        <ve-table :columns="columns2" :table-data="tableData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeamMemberTimeOff",
  data() {
    return {
      stats: [
        {
          name: "Annual",
          value: "15 Days",
        },
        {
          name: "Sick",
          value: "2 Days",
        },
        {
          name: "Compensation",
          value: "15 Days",
        },
        {
          name: "Maternity",
          value: "15 Days",
        },
        {
          name: "Study",
          value: "05 Days",
        },
      ],
      columns: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        { field: "From", key: "a", title: "From" },
        { field: "To", key: "b", title: "To" },
        { field: "Days", key: "c", title: "Days" },
        {
          field: "Type",
          key: "x",
          title: "Type",
        },
        { field: "Description", key: "d", title: "Description" },

        {
          field: "Attachment",
          key: "f",
          title: "Attachment",
          renderBodyCell: () => {
            return <p class="cursor-pointer font-bold">&#128206;</p>;
          },
        },
        {
          field: "Status",
          key: "g",
          title: "Status",
        },
        {
          field: "Action",
          key: "ff",
          title: "Action",
          renderBodyCell: () => {
            return (
              <p class="cursor-pointer transform rotate-90 font-bold">
                &#8230;
              </p>
            );
          },
        },
      ],
      columns2: [
        {
          field: "",
          key: "numbering",
          title: "",
          width: 50,
          align: "center",
          renderBodyCell: ({ rowIndex }) => {
            return ++rowIndex;
          },
        },
        { field: "From", key: "a", title: "From" },
        { field: "To", key: "b", title: "To" },
        { field: "Days", key: "c", title: "Days" },
        {
          field: "Type",
          key: "x",
          title: "Type",
        },
        { field: "Description", key: "d", title: "Description" },

        {
          field: "Attachment",
          key: "f",
          title: "Attachment",
          renderBodyCell: () => {
            return <p class="cursor-pointer font-bold">&#128206;</p>;
          },
        },
      ],
      tableData: [
        {
          From: "2020-01-01",
          To: "01/01/2020",
          Days: "4",
          Type: "Annual Leave",
          Description: "lorem ipsum dolor sit amet lorem ipsum dolor sit amet",
          Attachment: "",
          Status: "Approved",
        },
        {
          From: "2020-01-01",
          To: "01/01/2020",
          Days: "4",
          Type: "Annual Leave",
          Description: "lorem ipsum dolor sit amet lorem ipsum dolor sit amet",
          Attachment: "",
          Status: "Approved",
        },
        {
          From: "2020-01-01",
          To: "01/01/2020",
          Days: "4",
          Type: "Annual Leave",
          Description: "lorem ipsum dolor sit amet lorem ipsum dolor sit amet",
          Attachment: "",
          Status: "Approved",
        },
        {
          From: "2020-01-01",
          To: "01/01/2020",
          Days: "4",
          Type: "Annual Leave",
          Description: "lorem ipsum dolor sit amet lorem ipsum dolor sit amet",
          Attachment: "",
          Status: "Approved",
        },
      ],
    };
  },
  methods: {
    backToTeam() {
      this.$emit("backToTeam");
    },
  },
};
</script>